import {Button, ThemeProvider} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {theme} from "../Theme";

const LogoutButton: React.FC<{ onLogout: () => void }> = ({ onLogout }) => {
    const navigate = useNavigate();

    const handleLogout = () => {
        // 로컬 스토리지에서 accessToken 제거
        localStorage.removeItem('accessToken');
        console.log(localStorage.getItem('accessToken'))

        onLogout()
    };
    return (
        <ThemeProvider theme={theme}>
            <Button
                variant="contained"
                onClick={handleLogout}
                style={{ margin: '10px', backgroundColor: `${theme.palette.primary.main}` }}
            >
                로그아웃
            </Button>
        </ThemeProvider>
    );
}

export default LogoutButton